export class PdfPaths {
  public static welcome = "https://prestemos-assets.s3.amazonaws.com/pdf/2024_02-Nexu_Bienvenido.pdf";
  public static first_commitment_letter = "https://prestemos-assets.s3.amazonaws.com/pdf/first_commitment_letter.pdf";
  public static second_commitment_letter = "https://prestemos-assets.s3.amazonaws.com/pdf/second_commitment_letter.pdf";
}
